export enum Feature {
  AUTOMATION_WORKFLOW = 'automation_workflow',
  CONTAINER = 'container',
  CCA = 'cca',
}
